export default __webpack_public_path__ + "static/media/MICE-congress-dt@2x.a93e03a2.jpg";